/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Exercise_MachineInputs */

const en_us2_exercise_machine = /** @type {(inputs: Exercise_MachineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Machine: ${i?.name}`)
};

const pt_br2_exercise_machine = /** @type {(inputs: Exercise_MachineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Máquina: ${i?.name}`)
};

const es_419_exercise_machine = /** @type {(inputs: Exercise_MachineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Máquina: ${i?.name}`)
};

const pt_pt2_exercise_machine = /** @type {(inputs: Exercise_MachineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Máquina: ${i?.name}`)
};

const fr_fr2_exercise_machine = /** @type {(inputs: Exercise_MachineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Machine : ${i?.name}`)
};

const de_de2_exercise_machine = /** @type {(inputs: Exercise_MachineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gerät: ${i?.name}`)
};

const it_it2_exercise_machine = /** @type {(inputs: Exercise_MachineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Macchina: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Machine: {name}" |
*
* @param {Exercise_MachineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_machine = /** @type {((inputs: Exercise_MachineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_MachineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_machine(inputs)
	if (locale === "es-419") return es_419_exercise_machine(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_machine(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_machine(inputs)
	if (locale === "de-DE") return de_de2_exercise_machine(inputs)
	if (locale === "it-IT") return it_it2_exercise_machine(inputs)
	return en_us2_exercise_machine(inputs)
});
export { exercise_machine as "exercise.machine" }